import ArticleIcon from '@mui/icons-material/Article';
import DownloadIcon from '@mui/icons-material/Download';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTenantContractsDownloadUrl } from './hooks/useContractDownloadUrl';

interface Props {
  hasContracts: boolean;
}

export function ContractDownloadButton({ hasContracts }: Props) {
  const { t } = useTranslation('benefitsModule');
  const { mutate: generateContracts, isPending, isSuccess, data, reset } = useTenantContractsDownloadUrl();

  const hasDownloadUrl = isSuccess && !!data?.downloadUrl;

  const triggerDownload = (url: string) => {
    const a = document.createElement('a');
    a.href = url;
    a.download = '';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  const handleClick = () => {
    if (hasDownloadUrl) {
      triggerDownload(data.downloadUrl);
      reset();
      return;
    }

    generateContracts();
  };

  let label = t('extensions:bikeleasing_v2.contractsTable.startDownload');
  if (hasDownloadUrl) {
    label = t('extensions:bikeleasing_v2.contractsTable.downloadReady');
  } else if (isPending) {
    label = t('extensions:bikeleasing_v2.contractsTable.prepareDownload');
  }

  return (
    <Button
      variant="contained"
      loading={isPending}
      loadingPosition="start"
      onClick={handleClick}
      disabled={!hasContracts}
      startIcon={hasDownloadUrl ? <DownloadIcon /> : <ArticleIcon />}
    >
      {label}
    </Button>
  );
}
